import { Injectable } from '@angular/core';
import { NavigationEnd, Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { AuthService } from '../../app/modules/auth/services/auth.service';
import { filter } from 'rxjs/operators';
import { LeavePageService } from '../services/leave-page.service';

export interface ComponentAbleToDeactivate {
    canDeactivate: undefined | (() => Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree);
}

@Injectable({
    providedIn: 'root',
})
export class CanDeactivateGuard {
    private confirmationShown: boolean = false;

    constructor(private authService: AuthService, private router: Router, private leaveService: LeavePageService) {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
            this.leaveService.confirmationShown = false;
        });
    }

    canDeactivate(component: ComponentAbleToDeactivate): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // @ts-ignore
        if (!this.leaveService.confirmationShown) {
            this.leaveService.confirmationShown = true;
            return component.canDeactivate && this.authService.isLogged() ? component.canDeactivate() : true;
        } else {
            return true;
        }
    }
}
